import React from 'react';

export default class Tab extends React.Component {
	onClick = () => {
		const { label, onClick } = this.props;
		onClick(label);
	};

	render() {
		console.log('Tabs', this.props);
		const {
			onClick,
			props: {
				activeTab,
				label,
				tabBgColor = 'bg-white',
				tabWidth,
				isTextBold,
				isTabOutlined
			}
		} = this;

		let className = 'inline-block py-1 px-2.5 -m-px cursor:pointer';

		if (tabWidth) {
			className += ` ${tabWidth}`;
		}

		if (isTextBold) {
			className += ' font-bold';
		}
		if (isTabOutlined) {
			className +=
				' border-t-1 border-r-1 border-b-0 border-l-1 border rounded-t-md';
		}

		if (activeTab === label) {
			className += ` ${tabBgColor} border border-t-1 border-r-1 border-b-0 border-l-1 border rounded-t-md`;
		}

		return (
			<li className={className} onClick={onClick}>
				{label}
			</li>
		);
	}
}
